import useBranch from "@/shared/atoms/useBranch";
import useCommon from "@/shared/hooks/useCommon";
import useLoginAsCustomerMutation from "@/shared/mutations/auth/useLoginAsCustomerMutation";
import useMerchantUsersQuery from "@/shared/queries/user/useMerchantUsersQuery";
import { CmsUsersResponse } from "@/shared/utils/interfaces";
import { useEffect, useState } from "react";
import Button from "../Button/Button";
import Modal, { ModalProps } from "../Modal/Modal";
import BranchSelect from "../Select/BranchSelect";
import Select from "../Select/Select";

const LoginAsCustomerModal = ({ onExit, ...props }: ModalProps) => {
  const loginAsCustomer = useLoginAsCustomerMutation();
  const [currentBranch] = useBranch();
  const [branch, setBranch] = useState(currentBranch);
  const merchants = useMerchantUsersQuery(branch.id);
  const [user, setUser] = useState<CmsUsersResponse>(null);
  const t = useCommon();
  const onSelect = () => {
    loginAsCustomer
      .mutateAsync({
        username: user.item_id,
        group_item_id: 4,
      })
      .then((res) => {
        const url = `${import.meta.env.VITE_MIMIC_URL}/login?token=${
          res.token
        }&refresh_token=${res.refresh_token}`;
        onExit();
        window.open(url, "_blank", "width=800,height=600,noopener");
      });
  };

  useEffect(() => {
    setUser(null);
  }, [branch]);
  return (
    <Modal width={"80rem"} onExit={onExit} {...props}>
      <div className="pt-[2.5rem]">
        <BranchSelect
          showAllBox={false}
          value={branch}
          onChange={(group) => setBranch(group.branch)}
        />
        <div className="mt-[1rem]">
          <Select
            menuPlacement="bottom"
            styles={{
              menuPortal: (base) => ({
                ...base,
                zIndex: 9999,
              }),
            }}
            menuPortalTarget={document.getElementById("root")}
            options={merchants?.data}
            getOptionLabel={(option) => t(`${option.name}`)}
            getOptionValue={(option) => option.item_id}
            value={user}
            onChange={(user) => {
              setUser(user);
            }}
          />
        </div>
        <div className="my-8 flex gap-4">
          <Button
            isDisabled={user === null}
            isPending={merchants.isPending}
            onClick={onSelect}
          >
            {t("loginAsCustomer")}
          </Button>
          <Button onClick={() => onExit()}>{t("close")}</Button>
        </div>
      </div>
    </Modal>
  );
};

export default LoginAsCustomerModal;
